import * as sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import FlocknoteApp from "Flocknote";

import { getSentryEnvironment } from "./Utilities/Sentry/getSentryEnvironment";
import "./index.scss";

let Sentry = sentry.init({
  dsn: "https://f58ae101bf0f6cad2520590daeaa153b@o4508342913466368.ingest.us.sentry.io/4508342915563520",
  integrations: [],
  environment: getSentryEnvironment(),
  ignoreErrors: [
    /^Non-Error promise rejection captured with value?/,
    /^cordova already defined?/,
  ],
  // for even more control over what to send, use beforeSend: return null to not send
  // beforeSend(event) {
  //   console.log(event);
  //   return event;
  // },
});

window.Sentry = Sentry;

const container = document.getElementById("fnReactHolder");
const root = createRoot(container)

root.render(<FlocknoteApp />);